import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 380, damping: 38, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 380, damping: 38, mass: 0.6 });

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <motion.div className="cursor-ring" style={{ x: sx, y: sy }} aria-hidden="true">
      <svg viewBox="0 0 28 28" width="26" height="26" fill="none">
        <circle cx="14" cy="15" r="9" stroke="#a5854e" strokeWidth="1.6" />
        <circle cx="14" cy="15" r="9" stroke="rgba(248,243,234,.55)" strokeWidth="0.6" />
        <path
          d="M14 2.6 L17 5.8 L14 9 L11 5.8 Z"
          fill="#f7f2e8"
          stroke="#a5854e"
          strokeWidth="1"
        />
      </svg>
    </motion.div>
  );
}
